import produce from 'immer';
import { RequestLifecycle } from 'shared/actions';
import { CeaseActions, CeaseActionTypes } from './types/actions';
import { ICeaseState } from './types/store';

export const initialState: ICeaseState = {
  activeCustomerId: null,

  list: [],
  selected: null,
  lastCreated: null,

  getListState: null,
  getState: null,
  createState: null,

  errorMessage: null,
};

const reducer = produce((draft: ICeaseState, action: CeaseActions): void | ICeaseState => {
  switch (action.type) {
    case CeaseActionTypes.SET_ACTIVE_CUSTOMER: {
      const nextCustomerId = action.payload.customerId;
      if (draft.activeCustomerId !== nextCustomerId) {
        draft.activeCustomerId = nextCustomerId;
        draft.list = [];
        draft.selected = null;
        draft.lastCreated = null;
        draft.getListState = null;
        draft.getState = null;
        draft.createState = null;
        draft.errorMessage = null;
      }
      break;
    }

    case CeaseActionTypes.CREATE_CEASE_STARTED:
      draft.createState = RequestLifecycle.Loading;
      draft.errorMessage = null;
      break;

    case CeaseActionTypes.CREATE_CEASE_SUCCESS:
      draft.createState = RequestLifecycle.Success;
      draft.lastCreated = action.payload.cease;
      draft.selected = action.payload.cease;
      draft.errorMessage = null;
      break;

    case CeaseActionTypes.CREATE_CEASE_ERROR:
      draft.createState = RequestLifecycle.Error;
      draft.errorMessage = action.payload.message;
      break;

    case CeaseActionTypes.GET_CEASES_STARTED:
      draft.getListState = RequestLifecycle.Loading;
      draft.errorMessage = null;
      break;

    case CeaseActionTypes.GET_CEASES_SUCCESS:
      draft.getListState = RequestLifecycle.Success;
      draft.list = action.payload.ceases;
      draft.errorMessage = null;
      break;

    case CeaseActionTypes.GET_CEASES_ERROR:
      draft.getListState = RequestLifecycle.Error;
      draft.errorMessage = action.payload.message;
      break;

    case CeaseActionTypes.GET_CEASE:
      draft.getState = RequestLifecycle.Loading;
      draft.errorMessage = null;
      break;

    case CeaseActionTypes.GET_CEASE_STARTED:
      draft.getState = RequestLifecycle.Loading;
      draft.errorMessage = null;
      break;

    case CeaseActionTypes.GET_CEASE_SUCCESS:
      draft.getState = RequestLifecycle.Success;
      draft.selected = action.payload.cease;
      draft.errorMessage = null;
      break;

    case CeaseActionTypes.GET_CEASE_ERROR:
      draft.getState = RequestLifecycle.Error;
      draft.errorMessage = action.payload.message;
      break;

    case CeaseActionTypes.RESET_CEASE_ERROR:
      draft.errorMessage = null;
      break;

    default:
      return draft;
  }
}, initialState);

export default reducer;
